import {QueryCacheKeys} from '../../api/cache';
import {getCustomer} from '../../api/customers';
import {getInvoices} from '../../api/invoices';
import Layout from '../Layout';
import InvoiceTable from '../invoices/InvoiceTable';
import {Loader} from '@sproutsocial/racine';
import {useQuery} from '@tanstack/react-query';

interface CustomerInvoiceListProps {
	customerId: string;
}

const CustomerInvoiceList = ({customerId}: CustomerInvoiceListProps) => {
	const {data: customer} = useQuery({
		queryKey: QueryCacheKeys.customer(customerId),
		queryFn: () => getCustomer(customerId),
	});

	const {data: invoices} = useQuery({
		queryKey: QueryCacheKeys.customerInvoices(customerId),
		queryFn: () => getInvoices({customerId}),
	});

	if (!customer || !invoices) {
		return <Loader />;
	}

	return (
		<Layout>
			<Layout.Header title={`Invoices for ${customer.name}`} />
			<Layout.Body>
				<InvoiceTable invoices={invoices} showCustomerName={false} />
			</Layout.Body>
		</Layout>
	);
};

export default CustomerInvoiceList;
